module.exports = __webpack_public_path__ + "img/43.7d4add74.png";